import React, { Component } from "react";
import { AssetCard } from "@10x/dubai-rest-api/dist/property_registry/entity";
import Strings from "@my-dld/assets/strings";
import Popup from "@my-dld/components/Popup/Popup";
import PickerInput from "@eres/forms-web/PickerInput";
import { LocaleUtil } from "@eres/core";
import { WebFormFieldProps } from "@eres/forms-web";
import StateHolder from "@eres/forms/StateHolder";
import FormRow from "@eres/forms-web/FormRow";
import { ExternalValuationApi } from "../../valuationapi";
import { showErrorMessage } from "@my-dld/utils/UIUtils";
import { exToMessage } from "@eres/ssoapi/api";
import VCRankingItem from "../../components/ExternalValuation/VCRankingItem";
import { ValuationCompany } from "../../valuationapi/entities";
import { SpinnerLoader } from "@my-dld/components/SpinnerLoader";

interface Props {
	onClose: () => void,
	company: ValuationCompany,
}

interface State {
	property: AssetCard;
	classificationInfo?: any;
	classificationDetails: any[];
	year: any;
	showLoading: boolean;
}

class ValuationCompanyRankingDetails extends Component<Props, State> {
	apiHandler: any;
	apiExHandler: any;
	propertyId: any;

	constructor( props: any ) {
		super( props );
		this.state = {
			property: props.property,
			classificationDetails: [],
			year: ClassificationYears[ 0 ],
			showLoading: false
		};
	}

	componentDidMount() {
		this.loadClassificationDetails( ClassificationYears[ 0 ].id + "" );
	}

	componentWillReceiveProps( nextProps: Readonly<Props>, nextContext: any ) {
		this.loadClassificationDetails( ClassificationYears[ 0 ].id + "" );
	}

	loadClassificationDetails( key?: string ) {
		this.setState( { classificationDetails: [], showLoading: true } );
		ExternalValuationApi.getValuationClassificationDetails( this.props.company.realEstateNumber, key ? key : ClassificationYears[ 0 ].id + "", "valuation_office" ).then( ( response: any ) => {
			if ( response.ValidationErrorsList && response.ValidationErrorsList.length > 0 ) {
				showErrorMessage( ExternalValuationApi.getValidationError( response.ValidationErrorsList ) );
				this.setState( { showLoading: false } );
			} else {
				let classificationInfo = response.Response.Response[ 0 ];
				let rankData = classificationInfo.ClassificationDetails.reduce( ( ( result: any, currentValue: any ) => {
					if ( currentValue ) {
						const standardId = currentValue.StandardId;
						if ( !result.hasOwnProperty( standardId + "" ) ) {
							result[ standardId + "" ] = [];
						}
						result[ standardId + "" ].push( currentValue );
					}
					return result;
				} ), {} );
				let rankDetails: any[] = [];
				for ( let classificationRank in rankData ) {
					if ( rankData.hasOwnProperty( classificationRank ) ) {
						rankDetails.push( {
							standardId: classificationRank,
							classificationDetails: rankData[ classificationRank ],
						} );
					}
				}
				this.setState( { classificationDetails: rankDetails, classificationInfo: classificationInfo, showLoading: false } );
			}
		} )
		.catch( e => {
			this.setState( { showLoading: false } );
			exToMessage( e ).then( message => {
				let key = "newPwd";
				if ( message.src && message.src === "old" ) {
					key = "current";
				}
			} );
		} );
	}

	render() {
		const filedProps: Partial<WebFormFieldProps<any, any>> = {
			holder: StateHolder.buildStateHolder( this ),
			containerClassName: "col-md-12",
		};
		return <Popup
			modalSubContainer={ "modal-dialog modal-dialog-centered modal-lg" }
			id={ "ValuationCompanyRankingDetails" } title={ Strings.classification_office }
			onDismiss={ this.props.onClose }
			showIcon={ false }>
			<FormRow { ...filedProps }>
				<PickerInput
					required={ true }
					isLoading={ false }
					id={ "year" }
					toIdentifier={ idExtractor }
					label={ Strings.year }
					formatter={ ( year: any ) => LocaleUtil.getLocalValue( year.name ) }
					onValueChange={ ( year: any ) => {
						if ( year ) {
							this.setState( { year: year } );
							this.loadClassificationDetails( year.id + "" );
						} else {
							this.setState( { classificationDetails: [], showLoading: false } );
						}
					} }
					containerClassName={ "field-style select-control mb-3" }
					items={ ClassificationYears }/>
			</FormRow>
			<div className="row">

				{ this.state.classificationDetails && this.state.classificationDetails.map( ( value, index ) => {
					return <VCRankingItem rankingDetails={ value }/>;
				} ) }
				{ this.state.classificationDetails && this.state.classificationDetails.length > 0 && <div className="col-md-12">
					<div className="section-title">
						<h5>{ Strings.ranking_details }</h5>
					</div>
					<div className="flex-grid">
						<div>
							<span>{ Strings.total_points_ev }</span>
							<span>{ this.state.classificationInfo ? this.state.classificationInfo.RankValue : 0 }</span>
						</div>
					</div>
				</div> }

				{ this.state.year && !this.state.classificationDetails.length && !this.state.showLoading && <div className="col-md-12">
					<div className="alert alert-warning mb-0">{ Strings.no_data_available }</div>
				</div> }
				{ this.state.showLoading && <SpinnerLoader
					extraClass={ "spinner-border-sm mb-3" }/> }
			</div>
		</Popup>;
	}
}

function buildItemForYear( year: number ) {
	return { id: year, name: { en: year + "", ar: year + "" } };
}

const ClassificationYears = [
	buildItemForYear( 2018 ),
	buildItemForYear( 2019 ),
];
const idExtractor = ( e: any ) => e ? "" + e.id : undefined;
export default ValuationCompanyRankingDetails;
